import { Event } from '../Event'
import { ViewerContext } from '../../constants'
import { PathNodeMaterializedReference } from './types'

export interface PathClientFlowNodeViewedEventProperties {
  path_graph_flow_id: string
  nodes: PathNodeMaterializedReference[]
  navigation_direction: string
}

export class PathClientFlowNodeViewedEvent extends Event<PathClientFlowNodeViewedEventProperties> {
  static displayName = 'Path Client Flow Node Viewed'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
